"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SITPV_DESCRIPTION_MAX_LENGTH = void 0;
exports.validateControlledPrescriptionSettings = validateControlledPrescriptionSettings;
/** Longest treatment description we accept (the portal prints it in a single PDF box). */
exports.SITPV_DESCRIPTION_MAX_LENGTH = 500;
const isPositiveInteger = (n) => typeof n === 'number' && Number.isInteger(n) && n > 0;
/**
 * Validates the per-article SITPV settings against the portal form variant.
 *
 * @param settings  what would be stored in `hvpData.controlledPrescription`
 * @param formVariant  `integrations.sitpv.formVariant`, or `null` when the article is not linked yet
 */
function validateControlledPrescriptionSettings(settings, formVariant) {
    const errors = {};
    if (typeof settings.singleDose !== 'boolean')
        errors.singleDose = 'Indica si es dosis única';
    if (!isPositiveInteger(settings.factorL))
        errors.factorL = 'El factor L es un entero mayor que 0';
    if (formVariant == null) {
        errors.formVariant = 'Primero vincula el artículo con su medicamento de SITPV';
    }
    else if (formVariant === 3 || formVariant === 5) {
        errors.formVariant = `La variante ${formVariant} del formulario del portal no está implementada`;
    }
    else if (![1, 2, 4].includes(formVariant)) {
        errors.formVariant = `Variante del formulario desconocida: ${formVariant}`;
    }
    // Variants 1 and 2 ask for frequency and duration; a single dose forces 1 day (`dosisUnica`).
    if ((formVariant === 1 || formVariant === 2) && settings.singleDose === false) {
        if (!isPositiveInteger(settings.durationDays))
            errors.durationDays = 'La duración es un número entero de días mayor que 0';
    }
    if (settings.durationDays != null && !isPositiveInteger(settings.durationDays)) {
        errors.durationDays = 'La duración es un número entero de días mayor que 0';
    }
    if (formVariant === 4) {
        const text = (settings.description ?? '').trim();
        if (!text)
            errors.description = 'Este medicamento sólo lleva la descripción del tratamiento: escríbela';
        else if (text.length > exports.SITPV_DESCRIPTION_MAX_LENGTH) {
            errors.description = `La descripción no puede pasar de ${exports.SITPV_DESCRIPTION_MAX_LENGTH} caracteres`;
        }
    }
    if (settings.patientWeightKg != null && !(Number(settings.patientWeightKg) > 0 && Number(settings.patientWeightKg) <= 100)) {
        errors.patientWeightKg = 'El peso del paciente va de 0 a 100 kg';
    }
    if (settings.declaredFrequencyHours != null && !(isPositiveInteger(settings.declaredFrequencyHours) && settings.declaredFrequencyHours <= 168)) {
        errors.declaredFrequencyHours = 'La frecuencia declarada es un número entero de horas entre 1 y 168';
    }
    if (settings.packagesPerPurchaseUnit != null && !(isPositiveInteger(settings.packagesPerPurchaseUnit) && settings.packagesPerPurchaseUnit <= 1000)) {
        errors.packagesPerPurchaseUnit = 'Los envases de SENASICA por unidad de compra son un entero de 1 a 1000';
    }
    if ((settings.prescriptionNote ?? '').trim().length > exports.SITPV_DESCRIPTION_MAX_LENGTH) {
        errors.prescriptionNote = `La nota no puede pasar de ${exports.SITPV_DESCRIPTION_MAX_LENGTH} caracteres`;
    }
    return { isValid: Object.keys(errors).length === 0, errors };
}
